import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0927d7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node" }
const _hoisted_2 = {
  key: 2,
  class: "name"
}

import { Node } from "@/api/node-lookup";
import { startCase, kebabCase } from "lodash";
import { breadcrumbs } from "@/global/breadcrumbs";

interface Props {
  /** node represented by badge */
  node: Pick<Node, "id" | "name" | "category">;
  /** whether to include icon */
  icon?: boolean;
  /** whether to include link */
  link?: boolean;
  /**
   * breadcrumb object to add list when badge clicked on. include node that user
   * came from and relation between that node and this node.
   */
  breadcrumb?: Record<string, unknown>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNodeBadge',
  props: {
    node: null,
    icon: { type: Boolean, default: true },
    link: { type: Boolean, default: true },
    breadcrumb: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (__props.icon)
      ? _withDirectives((_openBlock(), _createBlock(_component_AppIcon, {
          key: 0,
          class: "icon",
          icon: `category-${_unref(kebabCase)(__props.node.category)}`
        }, null, 8, ["icon"])), [
          [_directive_tooltip, _unref(startCase)(__props.node.category)]
        ])
      : _createCommentVNode("", true),
    (__props.link)
      ? (_openBlock(), _createBlock(_component_AppLink, {
          key: 1,
          to: `/${__props.node.category}/${__props.node.id}`,
          state: 
        __props.breadcrumb ? { breadcrumbs: [..._unref(breadcrumbs), __props.breadcrumb] } : undefined
      
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.node.name || __props.node.id), 1)
          ]),
          _: 1
        }, 8, ["to", "state"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.node.name), 1))
  ]))
}
}

})